import { Alert, Skeleton } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import gql from 'graphql-tag';
import { useAuthedQuery } from 'utils/qlAuth';

export const LeonardoFramesAutomation = (props: { qStory: any; storyId: number }) => {
  const qFrames = useAuthedQuery(
    gql`
      query FrameController_getLeonardoFramesAutomation($storyId: Int!) {
        FrameController_getLeonardoFramesAutomation(storyId: $storyId)
      }
    `,
    {
      variables: { storyId: Number(props.storyId) },
    },
  );

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }

  const jsonString = qFrames.data?.FrameController_getLeonardoFramesAutomation;
  return (
    <>
      <Alert
        message="Leonardo.AI Image generation automation"
        description="Script for UI.Vision extension to automate images creation with Leonardo.AI. Copy this script to UI.Vision and run it to create images."
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />
      <TextArea rows={30} value={jsonString} />
    </>
  );
};
